import {
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState, useCallback } from "react";
import DialogSelectFanpages from "../Fanpages/Posts/Components/DialogSelectFanpages";
import { useTranslation } from "react-i18next";
import DialogAttachmentManager from "../../../Globals/DialogAttachmentManager";
import { LoadingButton } from "@mui/lab";
import api from "./../../../../Apis";
import { useCookies } from "react-cookie";
import SendIcon from "@mui/icons-material/Send";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getEncoding } from "js-tiktoken";
import TrainingHistoryList from "./Components/TrainingHistoryList";
import AIChatbotSettings from "./Components/AiChatbotSetting";
import SelectGroupFanpage from "./Components/SelectGroupFanpage";
import ChatIcon from "@mui/icons-material/Chat";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function AssistantTraining() {
  const navigate = useNavigate();
  const location = useLocation();
  const { fanpage_id, ai_id } = useParams();
  const { t } = useTranslation();
  const [cookies] = useCookies("is_login");
  
  // States
  const [tokenCount, setTokenCount] = useState(0);
  const [embedModelSelected, setEmbedModelSelected] = useState(null);
  const [repModelSelected, setRepModelSelected] = useState(null);
  const [models, setModels] = useState([]);
  const [embedModels, setEmbedModels] = useState([]);
  const [repModels, setRepModels] = useState([]);
  const [hasLoadedSettings, setHasLoadedSettings] = useState(false);
  const [isLoadingModels, setIsLoadingModels] = useState(false);
  const [trainingHistotyList, setTrainingHistoryList] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [state, setState] = useState({
    isLoading: false,
    isHistoryLoading: false,
    is_open_dialog_file_manager: false,
    fanpage_selected: [],
    list_fanpages: [],
    attachments: [],
    isUpdateFanpageInVectorLoading: false,
    list_group_fanpage: [],
    selected_group_fanpage: [],
  });

  const {
    control,
    formState: { errors },
    reset,
    watch,
    handleSubmit,
  } = useForm({
    mode: "onChange",
  });

  const enc = useMemo(() => getEncoding("cl100k_base"), []);

  //  LOAD FANPAGES
  useEffect(() => {
    const loadFanpages = async () => {
      try {
        setIsLoadingModels(true);
        const res = await fetch(api.get_fanpage, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookies.is_login}`,
          },
        });
        const data = await res.json();
        setState((prevState) => ({
          ...prevState,
          list_fanpages: data.datas.fanpage_actives,
        }));
      } catch (error) {
        console.error("Load fanpages error:", error);
      } finally {
        setIsLoadingModels(false);
      }
    };
    const loadGroupFanpages = async () => {
      try {
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.is_login}` },
        };

        const res = await fetch(api.group_fanpage, requestOptions)
        const data = await res.json();
        if(data?.success){
          setState((prevState) => ({
            ...prevState,
            list_group_fanpage: data?.data || []
          }));
        }        
      }catch (error) {
        console.error("Load group fanpages error:", error);
      }
    }

    loadFanpages();
    loadGroupFanpages();
  }, [cookies.is_login]);
  

  // LOAD MODELS
  useEffect(() => {
    const loadModels = async () => {
      try {
        setIsLoadingModels(true);
        const res = await fetch(api.gpt_assistant_models, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookies.is_login}`,
          },
        });
        const data = await res.json();
        
        if (data?.success && data?.data?.models) {
          const allModels = data.data.models;
          const modelSetting = data?.data?.model_setting;
          
          const embedModelsList = allModels.filter(model => model.type === "embed");
          const repModelsList = allModels.filter(model => model.type === "rep");
          
          setModels(allModels);
          setEmbedModels(embedModelsList);
          setRepModels(repModelsList);
          
          // Chỉ load setting nếu đã từng save (có modelSetting)
          // KHÔNG load nếu chưa từng save
          if (modelSetting?.ai_model_embed_id || modelSetting?.ai_model_rep_id) {
            setHasLoadedSettings(true);
            
            if (modelSetting?.ai_model_embed_id) {
              const savedEmbedModel = embedModelsList.find(
                model => model.id === modelSetting.ai_model_embed_id
              );
              if (savedEmbedModel) {
                setEmbedModelSelected(savedEmbedModel.name);
              }
            }
            
            if (modelSetting?.ai_model_rep_id) {
              const savedRepModel = repModelsList.find(
                model => model.id === modelSetting.ai_model_rep_id
              );
              if (savedRepModel) {
                setRepModelSelected(savedRepModel.name);
              }
            }
          }
        }
      } catch (error) {
        console.error("Load models error:", error);
      } finally {
        setIsLoadingModels(false);
      }
    };

    loadModels();
  }, [cookies.is_login]);

  // HANDLER: Lưu model setting
  const handleSaveModelSetting = useCallback(async (modelName, modelType) => {
    try {
      const model = models.find(m => m.name === modelName && m.type === modelType);
      
      if (!model) {
        console.error("Model not found");
        return;
      }

      const res = await fetch(api.gpt_assistant_ai_model_setting, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookies.is_login}`,
        },
        body: JSON.stringify({
          ai_model_id: model.id,
          model_type: modelType
        }),
      });

      const data = await res.json();

      if (data?.success) {
        setHasLoadedSettings(true);
        Swal.fire({
          icon: "success",
          title: "Thành công",
          text: `Đã lưu cài đặt ${modelType === 'embed' ? 'model dạy AI' : 'model AI trả lời'}!`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
        });
      } else {
        throw new Error(data?.message);
      }
    } catch (error) {
      console.error("Save model setting error:", error);
      Swal.fire({
        icon: "error",
        title: "Lỗi",
        text: error.message || "Có lỗi xảy ra khi lưu cài đặt model!",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  }, [models, cookies.is_login]);

  // HANDLER: Thay đổi Embed Model
  const handleEmbedModelChange = useCallback((e) => {
    const newModel = e.target.value;
    setEmbedModelSelected(newModel);
    handleSaveModelSetting(newModel, "embed");
  }, [handleSaveModelSetting]);

  // HANDLER: Thay đổi Rep Model
  const handleRepModelChange = useCallback((e) => {
    const newModel = e.target.value;
    setRepModelSelected(newModel);
    handleSaveModelSetting(newModel, "rep");
  }, [handleSaveModelSetting]);

  const fetchTrainingHistory = useCallback(async () => {
    try {
      setState((prevState) => ({ ...prevState, isHistoryLoading: true }));
      const res = await fetch(
        `${api.gpt_assistant_training_history}?page=${currentPage}&ai_bot_id=${ai_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookies.is_login}`,
          },
        }
      );
      const data = await res.json();
      if (data?.success) {
        setTrainingHistoryList(data?.data);
        setTotalPage(data?.total_page || 1);
      } else {
        throw new Error(data?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setState((prevState) => ({ ...prevState, isHistoryLoading: false }));
    }
  }, [cookies.is_login, currentPage, ai_id]);
  // HANDLER: Submit form
  const onSubmit = useCallback(async (values) => {
    // if (state.fanpage_selected.length === 0 && state.selected_group_fanpage.length === 0) {
    //   Swal.fire({
    //     icon: "warning",
    //     text: "Vui lòng chọn fanpage hoặc nhóm fanpage",
    //   });
    //   return;
    // }
    
    // if (!embedModelSelected) {
    //   Swal.fire({
    //     icon: "warning",
    //     text: "Vui lòng chọn model dạy AI",
    //   });
    //   return;
    // }

    try {
      const body = {
        text: "Hỏi: " + values.text + "\nTrả lời: " + values.answer,
        fanpage_ids: state.fanpage_selected
          .filter((item) => item.fanpage_id !== -1)
          .map((item) => item.fanpage_id),
        attachments: state.attachments.map((item) => item.url),
        model: embedModelSelected,
        group_ids: state.selected_group_fanpage,
        ai_bot_id: ai_id,
      }
      setState((prevState) => ({ ...prevState, isLoading: true }));
      
      const res = await fetch(api.gpt_assistant_create_vector, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookies.is_login}`,
        },
        body: JSON.stringify(body),
      });
      
      const data = await res.json();
      
      if (data?.success) {
        Swal.fire({
          icon: "success",
          text: data?.message,
        });
        fetchTrainingHistory();
        reset();
        setState((prevState) => ({ ...prevState, attachments: [], selected_group_fanpage: [] }));
      } else {
        Swal.fire({
          icon: "error",
          title: t("common.message.error"),
          text: data?.message || t("common.message.pleaseTryAgain"),
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
      Swal.fire({
        icon: "error",
        title: t("common.message.error"),
        text: t("common.message.pleaseTryAgain"),
      });
    } finally {
      setState((prevState) => ({ ...prevState, isLoading: false }));
    }
  }, [state.fanpage_selected, state.selected_group_fanpage, state.attachments, embedModelSelected, cookies.is_login, t, reset, ai_id, fetchTrainingHistory]);

  //  OTHER HANDLERS
  // const handleChangeFanpage = useCallback((fanpage_selected) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     fanpage_selected: fanpage_selected,
  //   }));
  // }, []);

  const updateImagePicked = useCallback((images) => {
    setState((prevState) => ({
      ...prevState,
      attachments: images,
    }));
  }, []);

  const removeAttachment = useCallback((index) => {
    setState((prevState) => ({
      ...prevState,
      attachments: prevState.attachments.filter((_, i) => i !== index),
    }));
  }, []);

  // const handleSelectGroupFanpageChange = (value) => {  
  //   setState({...state, selected_group_fanpage: value});
  // }
  // console.log(state.selected_group_fanpage);
   const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  

  useEffect(() => {
    fetchTrainingHistory();
  }, [fetchTrainingHistory]);

 
  
  return (
    <Container maxWidth="xl" className="m-t-40">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 101 }}
        open={state.isLoading || state.isUpdateFanpageInVectorLoading || isLoadingModels}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2, gap: 1 }}>
        <Box>
          <Button 
            variant="text" 
            startIcon={<ArrowBackIcon sx={{ fontSize: "22px !important"  }}/>}
            onClick={() => navigate("/dashboard/ai")}
            className="text-transform"
            sx={{
              fontSize: 22
            }}
          >
            {location.state?.ai_name}
          </Button>
        </Box>
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(`/dashboard/ai/chat/${ai_id}`)}
            sx={{ textTransform: "none" }}
            startIcon={<ChatIcon />}
            size="small"
          >
            Test AI Chatbot
          </Button>
        </Box>
      </Box>
      <Grid container style={{ justifyContent: "center" }}>
        <Grid item xs={12} md={4}>
          {/* <FormLabel 
            component="legend" 
            sx={{ 
              fontWeight: "bold", 
              fontSize: "1.1rem", 
              mb: 2,
              color: 'rxgba(0, 0, 0, 0.87)' 
            }}
          >
            Áp dụng cho Fanpage:
          </FormLabel> */}
          
          {/* <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <DialogSelectFanpages
              listFanpages={state.list_fanpages || []}
              handleChangeFanpage={handleChangeFanpage}
            />
            <Typography color="error">
              ({state.fanpage_selected.filter((item) => item.fanpage_id !== -1).length}) {t("post.selectedFanpage")}
            </Typography>
          </Box> */}
          {/* <SelectGroupFanpage
             selected_group_fanpages={state.selected_group_fanpage}
             onSelectGroupFanpageChange={handleSelectGroupFanpageChange}
             list_group_fanpage={state.list_group_fanpage}
          /> */}
          <div style={{ marginTop: "20px" }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* Ô THỨ NHẤT: NỘI DUNG KHÁCH HỎI */}
              <Box sx={{ mb: 2 }}>
                <FormLabel sx={{ fontWeight: "bold", mb: 1, display: "block", color: "#333" }}>
                  1. Nội dung khách hỏi:
                </FormLabel>
                <Controller
                  control={control}
                  name="text"
                  defaultValue=""
                  rules={{
                    required: {
                      value: true,
                      message: "Nội dung khách hỏi không được để trống",
                    },
                  }}
                  render={({ field }) => (
                    <textarea
                      {...field}
                      placeholder="Nhập nội dung khách hỏi..."
                      className="form-control"
                      rows={5} // Chiều cao vừa phải
                      style={{ resize: "none" }}
                      // onChange={(e) => {
                      //   field.onChange(e);
                      //   // Tính toán token: Lấy giá trị ô này + giá trị hiện tại của ô 'answer' trong form
                      //   const currentAnswer = watch("answer") || ""; 
                      //   const tokens = enc.encode(e.target.value + currentAnswer).length;
                      //   setTokenCount(tokens);
                      // }}
                    />
                  )}
                />
                {errors.text && (
                  <p style={{ color: "red", mt: "5px", fontSize: "14px" }}>
                    {errors.text.message}
                  </p>
                )}
              </Box>

              {/* Ô THỨ HAI: NỘI DUNG AI TRẢ LỜI */}
              <Box sx={{ mb: 2 }}>
                <FormLabel sx={{ fontWeight: "bold", mb: 1, display: "block", color: "#333" }}>
                  2. Nội dung AI trả lời:
                </FormLabel>
                <Controller
                  control={control}
                  name="answer" // Tên field mới
                  defaultValue=""
                  rules={{
                    required: {
                      value: true,
                      message: "Nội dung trả lời không được để trống",
                    },
                  }}
                  render={({ field }) => (
                    <textarea
                      {...field}
                      placeholder="Nhập nội dung bạn muốn AI trả lời mẫu..."
                      className="form-control"
                      rows={8} // Chiều cao ngắn hơn ô trên
                      style={{ resize: "none" }}
                      // onChange={(e) => {
                      //   field.onChange(e);
                      //   // Tính toán token: Lấy giá trị ô này + giá trị hiện tại của ô 'text' (khách hỏi)
                      //   const currentQuestion = watch("text") || "";
                      //   const tokens = enc.encode(currentQuestion + e.target.value).length;
                      //   setTokenCount(tokens);
                      // }}
                    />
                  )}
                />
                {errors.answer && (
                  <p style={{ color: "red", mt: "5px", fontSize: "14px" }}>
                    {errors.answer.message}
                  </p>
                )}
              </Box>

              {/* PHẦN ĐÍNH KÈM FILE */}
              <Box sx={{ display: "flex", flexDirection: "column", marginTop: "12px", gap: "20px" }}>
                <Button
                  onClick={() => setState({ ...state, is_open_dialog_file_manager: true })}
                  type="button"
                  className="text-transform"
                  variant="contained"
                  color="warning"
                  startIcon={<AddRoundedIcon />}
                >
                  {"Đính kèm ảnh/video khi AI trả lời"}
                </Button>
              </Box>

              {/* DANH SÁCH FILE ĐÃ CHỌN */}
              <Box sx={{ marginTop: "12px" }}>
                {state.attachments.map((item, i) => (
                  <Grid container spacing={2} key={i}>
                    <Grid item xs={10}>
                      <TextField
                        sx={{ marginBottom: "15px" }}
                        autoComplete="off"
                        size="small"
                        fullWidth
                        label={`Link ảnh thứ ${i + 1}`}
                        variant="outlined"
                        value={item.url}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Button
                        onClick={() => removeAttachment(i)}
                        variant="contained"
                        color="error"
                        size="medium"
                      >
                        {t("common.delete")}
                      </Button>
                    </Grid>
                  </Grid>
                ))}
              </Box>

              <LoadingButton
                loading={state.isLoading}
                fullWidth
                className="text-transform"
                variant="contained"
                style={{ marginTop: "10px" }}
                startIcon={<SendIcon />}
                type="submit"
              >
                Xác nhận
              </LoadingButton>
            </form>
          </div>
        </Grid>

        <Grid item xs={12} md={8} sx={{ paddingLeft: 5 }}>
          {/* <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            {embedModels.length > 0 && (
                <FormControl component="fieldset">
                  <FormLabel component="legend" sx={{ fontWeight: "bold", fontSize: "1.1rem", mb: 1, pt: 1, "&.Mui-focused": { color: 'rxgba(0, 0, 0, 0.87)' } }}>
                    Cài đặt model dạy AI
                  </FormLabel>
                  <RadioGroup value={embedModelSelected || ""} onChange={handleEmbedModelChange}>
                      {embedModels.map((model) => (
                        <FormControlLabel
                          key={model.id}
                          value={model.name}
                          control={<Radio />}
                          label={
                            <Box sx={{ py: 1 }}>
                              <Typography variant="body1" fontWeight="bold">
                                {model.name}
                              </Typography>
                            </Box>
                          }
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                )}

                {repModels.length > 0 && (
                  <FormControl component="fieldset">
                    <FormLabel component="legend" sx={{ fontWeight: "bold", fontSize: "1.1rem", mb: 1, "&.Mui-focused": { color: 'rgba(0, 0, 0, 0.87)' } }}>
                      Cài đặt model AI trả lời
                    </FormLabel>
                    <RadioGroup value={repModelSelected || ""} onChange={handleRepModelChange}>
                      {repModels.map((model) => (
                        <FormControlLabel
                          key={model.id}
                          value={model.name}
                          control={<Radio />}
                          label={
                            <Box sx={{ py: 1 }}>
                              <Typography variant="body1" fontWeight="bold">
                                {model.name}
                              </Typography>
                            </Box>
                          }
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
              )}

              <AIChatbotSettings
                listFanpages={state.list_fanpages}
                embedModelSelected={embedModelSelected}
                repModelSelected={repModelSelected}
                cookies={cookies.is_login}
              />
          </Box> */}
          <TrainingHistoryList
            is_login={cookies.is_login}
            isLoading={state.isHistoryLoading}
            setIsLoading={(isLoading) =>
              setState((prev) => ({ ...prev, isHistoryLoading: isLoading }))
            }
            setIsUpdateFanpageInVectorLoading={(isLoading) =>
              setState((prev) => ({ ...prev, isUpdateFanpageInVectorLoading: isLoading }))
            }
            setState={setState}
            listFanpages={state.list_fanpages}
            list_group_fanpage={state.list_group_fanpage}
            trainingHistotyList={trainingHistotyList}
            setTrainingHistoryList={setTrainingHistoryList}
            totalPage={totalPage}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        </Grid>
      </Grid>


      <DialogAttachmentManager
        isOpenDialogAttachment={state.is_open_dialog_file_manager}
        closeDialogAttachment={() =>
          setState((prev) => ({ ...prev, is_open_dialog_file_manager: false }))
        }
        cookie={cookies.is_login}
        fanpage_id={fanpage_id}
        page_name="posts"
        imageSelectedOld={[]}
        imagePicked={updateImagePicked}
      />
    </Container>
  );
}